<template :title="$t('menu.favorites')">
  <icon-button
    round
    class="favorite-toggler"
    :class="{
      'active-favorite-toggler': active
    }"
    :title="$t('menu.favorites')"
    @click="toggle"
  >
    <i-favorite
      class="favorite-icon"
      :title="null"
    ></i-favorite>
  </icon-button>
</template>

<script>
import IconButton from '@/components/buttons/IconButton'
import IFavorite from 'vue-material-design-icons/Star'

export default {
  components: {
    IconButton,
    IFavorite
  },
  props: {
    active: Boolean,
    type: {
      validator: function (value) {
        return [ 'league', 'event' ].indexOf(value) !== -1
      }
    },
    target: Number
  },
  methods: {
    toggle () {
      this.$store.commit('favorites/TOGGLE_' + this.type.toUpperCase(), this.target)
    }
  }
}
</script>

<style scoped>
.favorite-toggler { font-size: 16px; height: 30px; width: 30px; }
.favorite-icon { /* color: #fff; */ }
.active-favorite-toggler .favorite-icon { color: #8ce95d; }
</style>



// WEBPACK FOOTER //
// src/components/buttons/FavoriteToggler.vue